import React from 'react'
import {useTranslation} from 'react-i18next'

import PencilIcon from '~/assets/img/digital-receipts/pencil.svg'
import SoundIcon from '~/assets/img/digital-receipts/sound.svg'
import HeartIcon from '~/assets/img/digital-receipts/heart.svg'
import LoupeIcon from '~/assets/img/digital-receipts/loupe.svg'
import FlowerIcon from '~/assets/img/digital-receipts/flower.svg'

import styles from './styles.scss'

export const Advantages = () => {
    const {t} = useTranslation()

    const items = [
        {icon: PencilIcon, text: t('DigitalReceiptsAdvantages.item1')},
        {icon: SoundIcon, text: t('DigitalReceiptsAdvantages.item2')},
        {icon: HeartIcon, text: t('DigitalReceiptsAdvantages.item3')},
        {icon: LoupeIcon, text: t('DigitalReceiptsAdvantages.item4')},
        {icon: FlowerIcon, text: t('DigitalReceiptsAdvantages.item5')}
    ]

    return (
        <section className={styles.advantages}>
            <div className={styles.squares}>
                {items.map(({icon: Icon, text}, index) => (
                    <article className={styles.square} key={index}>
                        <div className={styles.iconWrapper}>
                            <img src={Icon} className={styles.icon} alt='' />
                        </div>

                        <p className={styles.text}>{text}</p>
                    </article>
                ))}
            </div>
        </section>
    )
}
